'use strict';

import angular from 'angular';
import SimpleMessages from '../../controllers/simple-messages';
import raven from 'raven';

class UsersController {
    /* @ngInject */
    constructor(
        $mdDialog,
        $scope,
        UsersService,
        $q,
        $mdToast,
        $timeout,
        focus
    ) {
        Object.assign(this, {
            $mdDialog,
            $scope,
            UsersService,
            $q,
            $mdToast,
            $timeout,
            focus
        });

        this.query = {
            limit: 10,
            page: 1
        };
        this.onPagination = () => {
            this.getUsers();
        };
        this.getUsers();
    }

    getUsers(opts = {}) {
        let qOpts = {
            where: {
            },
            page: this.query.page,
            limit: this.query.limit,
            include: ['roles']
        };

        let queryReady = this.UsersService
            .getModels(qOpts)
            .then(users => {
                this.users = users;
            });
        let countReady = this.UsersService
            .getCount(qOpts)
            .then(result => {
                this.usersCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }

    onToggleUser(user) {
        user.$save().then(() => {
            this.$mdToast.show(
                this.$mdToast.simple()
                    .content('Los cambios han sido guardados correctamente')
                    .position('top center')
                    .hideDelay(3000)
                    .toastClass('success')
                    .parent('users')
            );
        });
    }

    queryRoleSearch(user, text) {
        return this.UsersService.getAllRoles().then(
            (roles) => roles
                .filter(r => !user.roles.some(userRole => userRole.id == r.id))
                .filter(r => r.translatedName.match(
                    new RegExp(`.*${text}.*`, "i")
                ))
        );
    }

    addRole(user, role) {
        this.UsersService.addRole(user.id, role.id).then(() => {
            this.simpleSuccess();
        }, err => {
            raven.captureException(err);
            this.simpleError();
        });
    }

    removeRole(user, role) {
        this.UsersService.removeRole(user.id, role.id).then(() => {
            this.simpleSuccess();
        }, err => {
            raven.captureException(err);
            this.simpleError();
        });
    }

    translateRoleName(name) {
        return this.UsersService.translateRoleName(name);
    }
}
Object.assign(UsersController.prototype, SimpleMessages);
export default UsersController;
